// services/movimientoCajaService.ts
import { axiosInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';
import { operatorHeaders, requireOperatorToken } from './operatorGrant';

const API_URL = 'movimientos-caja/';

export interface MovimientoCaja {
    id: number;
    sesion: number;
    tipo: 'entrada' | 'salida';
    monto: number;
    descripcion: string;
    fecha: string;
    usuario: number;
    usuario_nombre?: string;
}

/**
 * Asiento manual del libro de caja. El backend exige el grant del operador
 * (``X-POS-Operator-Token``) para la caja ``sesion`` y atribuye el asiento a
 * ese operador; sin grant no se llama al servidor.
 */
export const registrarMovimiento = async (data: {
    sesion: number;
    tipo: 'entrada' | 'salida';
    monto: number;
    descripcion: string;
}, operadorToken: string | null | undefined): Promise<MovimientoCaja> => {
    const config = operatorHeaders(requireOperatorToken(operadorToken));
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data, config);
        return response.data;
    });
};

// services/pos/movimientoCajaService.ts
// services/pos/movimientoCajaService.ts
export const obtenerMovimientosPorSesion = async (sesionId: number): Promise<MovimientoCaja[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}?sesion=${sesionId}`);

        // Asegurarse de que solo obtenemos movimientos de la sesión específica
        return response.data
            .filter((movimiento: any) => movimiento.sesion === sesionId)
            .map((movimiento: any) => ({
                ...movimiento,
                monto: Number(movimiento.monto)
            }));
    });
};

